import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GlobalService } from './global.service';

@Injectable({
  providedIn: 'root'
})
export class ClubsService {

  constructor(public globalService: GlobalService, private http: HttpClient) { }

  //DEVUELVE LAS LISTA DE CLUBS
  public lista(): Observable<any> {
    let parametros = {
      usuario: this.globalService.usuario.clave,
      todosclubs: this.globalService.usuario.todosclubs,
      token: this.globalService.usuario.token,
      tipo: this.globalService.usuario.tipousuarioweb,
      clubasociado: this.globalService.usuario.clubasociado
    };
    console.log(parametros);
    return this.http.post(this.globalService.api + 'clubs/lista.php', parametros).map(
      (response) => {

        return response;
      }
    );
  }
  //DEVUELVE LAS LISTA DE todos los CLUBS
  public listatodos(): Observable<any> {
    let parametros = {
      usuario: this.globalService.usuario.clave,
      todosclubs: this.globalService.usuario.todosclubs,
      token: this.globalService.usuario.token,
      tipo: this.globalService.usuario.tipousuarioweb,
      clubasociado: this.globalService.usuario.clubasociado
    };
    console.log(parametros);
    return this.http.post(this.globalService.api + 'clubs/listatodos.php', parametros).map(
      (response) => {

        return response;
      }
    );
  }
  //DEVUELVE LOS DATOS DE UN CLUB
  public ficha(clave): Observable<any> {
    let parametros = {
      token: this.globalService.usuario.token,
      clave: clave
    };
    console.log(parametros);
    return this.http.post(this.globalService.api + 'clubs/ficha.php', parametros).map(
      (response) => {
        return response;
      }
    );
  }

  //DEVUELVE LOS DATOS DE UN CLUB
  public riesgo(clave): Observable<any> {
    let parametros = {
      token: this.globalService.usuario.token,
      clave: clave
    };
    console.log(parametros);
    return this.http.post(this.globalService.api + 'clubs/riesgo.php', parametros).map(
      (response) => {
        return response;
      }
    );
  }

  //DEVUELVE LOS EQUIPOS DE UN CLUB
  public listaequipos(clave): Observable<any> {
    let parametros = {
      token: this.globalService.usuario.token,
      clave: clave
    };
    console.log(parametros);
    return this.http.post(this.globalService.api + 'clubs/listaequipos.php', parametros).map(
      (response) => {
        return response;
      }
    );
  }

  //DEVUELVE TIPOS DE CLIENTE
  public tiposcliente(): Observable<any> {
    let parametros = {
      token: this.globalService.usuario.token
    };
    console.log(parametros);
    return this.http.post(this.globalService.api + 'clubs/tipos.php', parametros).map(
      (response) => {
        return response;
      }
    );
  }
  //DEVUELVE CONTACTOS CLIENTE
  public contacto(claveclub, tipo): Observable<any> {
    let parametros = {
      token: this.globalService.usuario.token,
      claveclub: claveclub,
      tipo: tipo
    };
    console.log(parametros);
    return this.http.post(this.globalService.api + 'clubs/contacto.php', parametros).map(
      (response) => {
        return response;
      }
    );
  }

  //INSERTA CLUB
  public insert(cliente, contacto, entrega): Observable<any> {

    if (cliente.descripcion == undefined) {
      cliente.descripcion = '';
    }

    if (cliente.rsocial == undefined) {
      cliente.rsocial = '';
    }

    if (cliente.localidad == undefined) {
      cliente.localidad = '';
    }

    if (cliente.mail == undefined) {
      cliente.mail = '';
    }

    if (cliente.provincia == undefined) {
      cliente.provincia = '';
    }
    if (cliente.tipocliente > 0) {

    } else {
      cliente.tipocliente = 0;
    }
    if (cliente.direccion == undefined) {
      cliente.direccion = '';
    }
    if (cliente.web == undefined) {
      cliente.web = '';
    }
    if (cliente.telefono == undefined) {
      cliente.telefono = '';
    }
    if (cliente.cif == undefined) {
      cliente.cif = '';
    }
    if (cliente.comentario == undefined) {
      cliente.comentario = '';
    }
    if (cliente.codigopostal == undefined) {
      cliente.codigopostal = '';
    }

    if (contacto.nombre == undefined) {
      contacto.nombre = '';
    }
    if (contacto.puesto == undefined) {
      contacto.puesto = '';
    }
    if (contacto.telefono == undefined) {
      contacto.telefono = '';
    }
    if (contacto.mail == undefined) {
      contacto.mail = '';
    }

    if (entrega.nombre == undefined) {
      entrega.nombre = '';
    }
    if (entrega.puesto == undefined) {
      entrega.puesto = '';
    }
    if (entrega.telefono == undefined) {
      entrega.telefono = '';
    }
    if (entrega.mail == undefined) {
      entrega.mail = '';
    }


    let parametros = {
      token: this.globalService.usuario.token,
      descripcion: cliente.descripcion,
      rsocial: cliente.rsocial,
      localidad: cliente.localidad,
      mail: cliente.mail,
      provincia: cliente.provincia,
      tipocliente: cliente.tipocliente,
      comercial: this.globalService.usuario.clave,
      direccion: cliente.direccion,
      web: cliente.web,
      telefono: cliente.telefono,
      cif: cliente.cif,
      codigopostal: cliente.codigopostal,
      comentario: cliente.comentario,
      contacto_tipo: 1,
      contacto_nombre: contacto.nombre,
      contacto_puesto: contacto.puesto,
      contacto_telefono: contacto.telefono,
      contacto_mail: contacto.mail,
      entrega_tipo: 2,
      entrega_nombre: entrega.nombre,
      entrega_puesto: entrega.puesto,
      entrega_telefono: entrega.telefono,
      entrega_mail: entrega.mail,
    };
    console.log('+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>');
    console.log(parametros);
    return this.http.post(this.globalService.api + 'clubs/insert.php', parametros).map(
      (response) => {
        console.log(response);
        return response;
      }
    );
  }
  //INSERTA CONTACTO
  public insertcontacto(contacto, tipo, cliente): Observable<any> {
    let parametros = {
      token: this.globalService.usuario.token,

      contacto_tipo: tipo,
      contacto_nombre: contacto.nombre,
      contacto_puesto: contacto.puesto,
      contacto_telefono: contacto.telefono,
      contacto_mail: contacto.mail,
      clave_cliente: cliente

    };
    console.log('+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>');
    console.log(parametros);
    return this.http.post(this.globalService.api + 'clubs/insertcontacto.php', parametros).map(
      (response) => {
        console.log(response);
        return response;
      }
    );
  }
  //MODIFICA CONTACTO
  public updatecontacto(contacto, tipo): Observable<any> {
    let parametros = {
      token: this.globalService.usuario.token,
      contacto_clave: contacto.clave,
      contacto_nombre: contacto.nombre,
      contacto_puesto: contacto.puesto,
      contacto_telefono: contacto.telefono,
      contacto_mail: contacto.mail,

    };
    console.log('+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>');
    console.log(parametros);
    return this.http.post(this.globalService.api + 'clubs/updatecontacto.php', parametros).map(
      (response) => {
        console.log(response);
        return response;
      }
    );
  }

  onUpload(file, id): Observable<any> {

    let parametros = {
      token: this.globalService.usuario.token,
      claveclub: id,
      imagen: file
    };
    console.log(parametros);
    return this.http.post(this.globalService.api + 'clubs/imagen.php', parametros).map(
      (response) => {
        console.log(response);
        return response;
      }
    );
  }

  //DEVUELVE ESTADISTICA DE PEDIDOS
  public estadistica_pedidos(x, filtro): Observable<any> {
    console.log('');
    console.log(filtro);

    if (filtro.filtro_f_desde == undefined) {
      filtro.filtro_f_desde = '';
    }
    if (filtro.filtro_f_hasta == undefined) {
      filtro.filtro_f_hasta = '';
    }
    let parametros = {
      token: this.globalService.usuario.token,
      usuario: this.globalService.usuario.clave,
      clave: x,
      filtro_f_desde: filtro.filtro_f_desde,
      filtro_f_hasta: filtro.filtro_f_hasta
    };
    console.log(parametros);
    return this.http.post(this.globalService.api + 'clubs/estadistica_pedidos.php', parametros).map(
      (response) => {
        console.log(response);
        return response;
      }
    );
  }
  //DEVUELVE ESTADISTICA DE PEDIDOS
  public estadistica_albaranes(x, filtro): Observable<any> {
    console.log('');
    console.log(filtro);

    if (filtro.filtro_f_desde == undefined) {
      filtro.filtro_f_desde = '';
    }
    if (filtro.filtro_f_hasta == undefined) {
      filtro.filtro_f_hasta = '';
    }
    let parametros = {
      token: this.globalService.usuario.token,
      usuario: this.globalService.usuario.clave,
      clave: x,
      filtro_f_desde: filtro.filtro_f_desde,
      filtro_f_hasta: filtro.filtro_f_hasta
    };
    console.log(parametros);
    return this.http.post(this.globalService.api + 'clubs/estadistica_albaranes.php', parametros).map(
      (response) => {
        return response;
      }
    );
  }
  //DEVUELVE LOS DATOS DE UN CLUB
  public direcciones(clave): Observable<any> {
    let parametros = {
      token: this.globalService.usuario.token,
      claveclub: clave
    };
    console.log(parametros);
    return this.http.post(this.globalService.api + 'clubs/direcciones.php', parametros).map(
      (response) => {
        return response;
      }
    );
  }

  public guardadireccion(direccion): Observable<any> {
    let parametros = {
      token: this.globalService.usuario.token,
      claveclub: this.globalService.club.clave,
      direccion: direccion.direccion,
      localidad: direccion.localidad,
      provincia: direccion.provincia,
      codigopostal: direccion.codigopostal,
      nombre: direccion.nombre,
      clave: direccion.clave,
      telefono: direccion.telefono,
      email: direccion.email,
      contacto: direccion.contacto
    };
   
    console.log(parametros);
    return this.http.post(this.globalService.api + 'clubs/guardadireccion.php', parametros).map(
      (response) => {
        console.log(response);
        return response;
      }
    );
  }
}
